var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettings = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.5,
    d: "M16.63 11.755l-1.578 2.733-1.813-.728-.507-.204-.446.318c-.348.248-.68.44-1.012.59l-.5.226-.078.544-.276 1.928H7.268l-.276-1.929-.078-.543-.501-.226c-.346-.156-.684-.352-1.008-.586l-.447-.322-.51.205-1.812.727-1.579-2.732 1.536-1.202.436-.34-.057-.55c-.024-.23-.034-.417-.034-.583 0-.166.01-.353.034-.582l.057-.55-.435-.34-1.538-1.203 1.58-2.733 1.813.728.507.204.445-.317c.348-.248.681-.44 1.011-.59l.502-.225.078-.544L7.268 1h3.151l.276 1.928.079.544.502.226c.344.155.682.35 1.007.585l.447.322.51-.205 1.812-.727 1.579 2.732-1.537 1.202-.439.342.06.554c.02.175.034.373.034.577 0 .202-.015.4-.034.581l-.058.551.437.341 1.536 1.202z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.5,
    cx: 9,
    cy: 9,
    r: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/settings.f31049e6.svg";
export { ForwardRef as ReactComponent };